/** Tailwind `md` — mobile app shell (tabs) vs desktop header. */
export const BREAKPOINT_MD_PX = 768;

/** Map UI treats viewports below this as “mobile map” (fullscreen search, fixed overlays). */
export const BREAKPOINT_MAP_MOBILE_PX = 1024;

export const MEDIA_MOBILE = `(max-width: ${BREAKPOINT_MD_PX - 1}px)` as const;
export const MEDIA_DESKTOP = `(min-width: ${BREAKPOINT_MD_PX}px)` as const;
export const MEDIA_MAP_MOBILE = `(max-width: ${BREAKPOINT_MAP_MOBILE_PX - 1}px)` as const;
export const MEDIA_MAP_DESKTOP = `(min-width: ${BREAKPOINT_MAP_MOBILE_PX}px)` as const;

/** Minimum recommended touch target (Apple HIG / Material). */
export const MIN_TOUCH_TARGET_PX = 44;
